<div class="page-editor-container">
  <!-- Editor Section (Left) -->
  <div class="editor">
    <h2>Edit Page Content</h2>
    
    <!-- Dropdown menu to select a component -->
    <div class="form-group">
      <label for="componentSelect">Choose a Component:</label>
      <select id="componentSelect" [(ngModel)]="selectedComponent" (change)="onComponentChange()" class="form-control">
        <option *ngFor="let comp of availableComponents" [value]="comp">
          {{ comp | titlecase }}
        </option>
      </select>
    </div>
  
    <br>
  
    <!-- Textarea for editing content -->
    <div class="form-group">
      <label for="contentEditor">Content for {{ selectedComponent | titlecase }} Component:</label>
      <textarea id="contentEditor" [(ngModel)]="content" (ngModelChange)="updatePreview()" rows="10" class="form-control"></textarea>
    </div>
  
    <br>
  
    <!-- Button to save the content -->
    <button (click)="saveContent()" class="btn btn-primary">Save Content</button>
    <p *ngIf="message">{{ message }}</p>
  </div>
  
  <!-- Preview Section (Right) -->
  <div class="preview">
    <h3>Preview</h3>
    <div [innerHTML]="safeContent"></div>
  </div>
</div>
